import { drop, figure, flames, flower, heart, needle, palm, petal, slash, cloud } from '../kit';
import { C, mix, type Pix } from '../pix';
import { registerIcons } from '../store';

/** ฝ่ามือมารสราญรมย์ (สราญรมย์, yin): violet demon hands, poison green, peach blossom and charm pink. */

const HAND = '#e8b8f0';
const NAIL = '#c070ff';
const PINK = '#ff8ad0';
const POISON = C.poison;

/** A soul wisp: a teardrop flame with a tail. */
function wisp(p: Pix, x: number, y: number): void {
  p.ell(x, y, 4, 4, '#d8f0ff');
  p.poly(
    [
      [x - 3, y - 1],
      [x - 1, y - 8],
      [x + 3, y - 1],
    ],
    '#d8f0ff',
  );
  p.px(x - 1, y, C.ink).px(x + 1, y, C.ink);
  p.path(
    [
      [x + 2, y + 3],
      [x + 5, y + 6],
      [x + 4, y + 9],
    ],
    '#a8c8ff',
  );
}

registerIcons('skill', {
  // A demon's claw rakes, its nails dripping poison.
  'jl-claw': (p) => {
    for (let k = 0; k < 3; k++) {
      p.thick(12 + k * 6, 4, 4 + k * 6, 26, NAIL, 3);
      p.line(13 + k * 6, 4, 5 + k * 6, 26, '#f0d0ff');
    }
    for (const [x, y] of [
      [9, 28],
      [16, 27],
      [22, 28],
    ] as const)
      drop(p, x, y, 1.6, POISON);
    drop(p, 26, 12, 2.2, POISON);
  },
  // Four shadow needles, their points green.
  'jl-needle': (p) => {
    for (let k = 0; k < 4; k++) {
      const y = 7 + k * 5;
      p.line(3 + k, y + 4, 9 + k, y + 2, mix(NAIL, C.ink, 0.3));
      needle(p, 8 + k, y + 2, 27 - k, y - 4 + k, '#e8e0f0', POISON);
      p.px(26 - k, y - 3 + k, POISON);
    }
    drop(p, 6, 27, 2, POISON);
  },
  // A charm spell: a heart pulsing out in rings.
  'jl-charm': (p) => {
    p.ring(16, 16, 13, 13, PINK, -2.9, -0.2);
    p.ring(16, 16, 10, 10, mix(PINK, C.white, 0.4), 0.3, 2.8);
    heart(p, 16, 16, 7, PINK);
    heart(p, 6, 7, 2.2, PINK);
    heart(p, 26, 25, 2.2, PINK);
  },
  // Three illusions step at once; only one is real.
  'jl-step': (p) => {
    figure(p, 13, 11, mix(NAIL, C.ink, 0.45), 'run');
    figure(p, 18, 10, mix(NAIL, C.ink, 0.15), 'run');
    figure(p, 23, 9, HAND, 'run', { head: C.skin });
    for (const y of [13, 17, 21]) p.line(10, y, 15, y, mix(NAIL, C.white, 0.3));
  },
  // A palm draws the soul out of the body.
  'jl-soul': (p) => {
    palm(p, 17, 2, HAND, { flip: true, lines: NAIL });
    wisp(p, 10, 17);
    p.path(
      [
        [13, 13],
        [17, 10],
        [20, 9],
      ],
      '#a8c8ff',
    );
  },
  // Blood drunk through the palm to the heart.
  'jl-drain': (p) => {
    palm(p, 3, 5, HAND, { lines: NAIL });
    for (let k = 0; k < 6; k++) p.rect(14 + k * 2, 22 - Math.round(Math.sin(k / 1.6) * 6), 2, 2, C.blood);
    heart(p, 24, 25, 4, C.blood);
  },
  // Peach blossom bursting open in a poison haze.
  'jl-bloom': (p) => {
    cloud(p, 3, 29, 26, mix(POISON, C.ink, 0.15));
    flower(p, 11, 12, 7, '#ffb0d8', C.gold);
    flower(p, 22, 17, 5, PINK, C.gold);
    flower(p, 9, 23, 4, PINK, C.gold);
    petal(p, 24, 5, '#ffb0d8');
    petal(p, 27, 26, '#ffb0d8');
  },
  // The demon's palm rises out of hellfire.
  'jl-abyss': (p) => {
    flames(p, 3, 29, 26, 12, '#8a3ad8', '#d89aff');
    palm(p, 9, 4, '#a070d0', { lines: '#5a2a8a' });
    for (const x of [9, 12, 15, 18]) p.px(x + 2, 4, NAIL);
    slash(p, 16, 15, 13, -2.6, -0.6, NAIL, 2);
  },
});
